'use client';

import useCountdown from '@/hooks/useCountdown';
import {
  formatFlashSaleCountdown,
  isFlashSaleActive,
  parseApiDate,
} from '@/utils/product';
import { useTranslations } from 'next-intl';

const FlashSaleCountdown = ({
  startDate,
  endDate,
  className = 'absolute start-0 top-2 z-25 max-sm:top-0',
}) => {
  const t = useTranslations('product');
  const end = parseApiDate(endDate);
  const { days, hours, minutes, seconds, isExpired } = useCountdown(end);

  if (!isFlashSaleActive(startDate, endDate) || isExpired) return null;

  return (
    <div
      className={`flex w-fit items-center gap-1 rounded-full bg-[#c62828] px-2.25 py-0.75 text-xs font-bold whitespace-nowrap text-white sm:text-sm ${className}`}
    >
      <span>{t('ends_after')}</span>
      <span>{formatFlashSaleCountdown({ days, hours, minutes, seconds })}</span>
    </div>
  );
};

export default FlashSaleCountdown;
